import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CustomInput, Button } from 'reactstrap';
import Loader from 'react-loaders';
import { api } from '../../_services/api.service';
import {  userService } from '../../_services/user.service';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import DatePicker from 'react-datepicker';
import GeneralGrid from '../../Components/GeneralGrid';
import { formatDate } from '../../_helpers/dateTimeHelper';
import {
    toast
} from 'react-toastify';
import 'braintree-web';
import DropIn from 'braintree-web-drop-in-react';
import swal from 'sweetalert';
import Braintree from '../../Components/Braintree';

const FullProfileWithPaiment = (props) => {

    const currentUser = userService.getLoggedInUser();
    const hiddenFileInput = React.useRef(null);

    let userId = parseInt(props.match.params.userId);
    let [user, setUser] = useState(null);
    let [isLoading, setIsLoading] = useState(false);
    let [userScenarios, setUserScenarios] = useState([]);
    let [userPartners, setUserPartners] = useState([]);
    let [isActionSubmitting, setIsActionSubmitting] = useState(false);

    const successToastOpts = {
        autoClose: 3000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: false
    };

    useEffect(() => {
        loadData(userId);
    }, [])

    const loadData = (userId) => {
        setIsLoading(true);
        api.getUserById(userId).then(data => {
            api.getUserPhotoBase64(userId).then(uri => {
                if (data.userSubscriptionStartDT == undefined || data.userSubscriptionStartDT == null) {
                    data.userSubscriptionStartDT = new Date(2020, 1, 1);
                } else {
                    data.userSubscriptionStartDT = new Date(data.userSubscriptionStartDT);
                }
                
                setUser({ ...data, imageUri: uri });
                setIsLoading(false);
            })
        })

        api.getScenariosByUser(userId).then(data => {
            setUserScenarios(data);
        })

        api.getPartnersByUser(userId).then(data => {
            setUserPartners(data);
        })
    }

    const handleSubmit = (e, errors, values) => {
        if (errors.length == 0) {
            api.updateUser(userId, user).then(data => {
                toast("User updated successfuly", successToastOpts);
                api.getUserById(userId).then(updatedUser => {
                    updatedUser.userId = updatedUser.userID;
                    updatedUser.roleId = updatedUser.roleID;
                    updatedUser.partnerId = updatedUser.partnerID;
                    updatedUser.password = "";
                    updatedUser.userSubscriptionStartDT = new Date(updatedUser.userSubscriptionStartDT);
                    updatedUser.imageUri = user.imageUri;
                    setUser(updatedUser);
                })
            })

        }
    }

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    const handleChange = event => {
        const fileUploaded = event.target.files[0];
        getBase64(fileUploaded, (res) => {
            setUser({ ...user, imageUri: res });
            let data = res.indexOf(',') > -1 ? res.split(',')[1] : res;
            api.updateUserPhotoBase64(user.userID, data).then(r => {
                //window.location.reload(false);
            });
        })
    };

    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const downloadReport = (scenarioId) => {
        if (!isActionSubmitting) {
            setIsActionSubmitting(true);
            api.getScenarioReportQueryParam(currentUser.userId).then(queryParam => {
                setIsActionSubmitting(false);
                let url = api.getScenarioReportUrl(currentUser.userId, scenarioId, queryParam);
                var win = window.open(url, '_blank');
                win.focus();
            })
        }
    }

    const partnercolumns = [
        {
            dataField: 'partner',
            text: 'Partner',
            sort: true,
            headerStyle: () => {
                return { width: "30%" };
            },
            // formatter: (content, row) => {
            //     return <a href='#' onClick={e => {
            //         e.preventDefault();
            //         props.history.push({
            //             pathname: `/partnersettings/${row.partnerID}`
            //         });
            //     }}>{content}</a>
            // }
        },
        {
            dataField: 'partnerRole',
            text: 'Role',
            sort: true,
            headerStyle: () => {
                return { width: "30%" };
            }
        },
        {
            dataField: 'partnerSubscriptionType',
            text: 'Subscription Type',
            sort: true,
            headerStyle: () => {
                return { width: "30%" };
            }
        },
        {
            dataField: 'partnerSubscriptionStatus',
            text: 'Subscription Status',
            sort: true,
            headerStyle: () => {
                return { width: "30%" };
            }
        }

    ];

    const partnerdefaultSorted = [{
        dataField: 'partnerName',
        order: 'asc'
    }];

    const partneroptions = {
        sizePerPageList: [
            {
                text: '50',
                value: 50
            }
        ],
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true
    }

    const columns = [
        {
            dataField: 'scenarioName',
            text: 'Model',
            sort: true,
            headerStyle: () => {
                return { width: "20%" };
            }
        },
        {
            dataField: 'createDT',
            text: 'Date',
            sort: true,
            headerStyle: () => {
                return { width: "20%" };
            },
            formatter: (content, row) => {
                return formatDate(content, true);
            }
        },
        {
            dataField: 'numObjectives',
            text: '# Criteria',
            sort: true,
            headerStyle: () => {
                return { width: "10%" };
            },
        },
        {
            dataField: 'numAlternatives',
            text: '# Alternatives',
            sort: true,
            headerStyle: () => {
                return { width: "10%" };
            },
        },
        {
            dataField: 'numParticipants',
            text: '# Participants',
            sort: true,
            headerStyle: () => {
                return { width: "10%" };
            },
        },
        {
            dataField: 'selectedAlternativeName',
            text: 'Selected Alternative',
            sort: true,
            headerStyle: () => {
                return { width: "20%" };
            },
        },

        {
            dataField: 'scenarioId',
            text: '',
            sort: true,
            headerStyle: () => {
                return { width: "10%" };
            },
            formatter: (content, row) => {
                return <Button color="primary" onClick={() => downloadReport(row.scenarioID)}>Report</Button>
            }
        }
    ];

    const defaultSorted = [{
        dataField: 'ScenarioName',
        order: 'asc'
    }];

    const options = {
        sizePerPageList: [
            {
                text: '50',
                value: 50
            }
        ],
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true
    }

    const getUserInitials = (user) => {
        return user.firstName[0] + user.lastName[0];
    }

    return (
        <Fragment>
            {isLoading && <Loader style={{}} type="ball-pulse" active />}
            {!isLoading && user !== null &&
                <Row style={{ marginTop: '30px' }}>
                    <Col md="6">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <div style={{ textAlign: 'center' }}>
                                    {user.imageUri !== undefined && user.imageUri !== '' &&
                                        <img width={100} height={100}
                                            className="rounded-circle"
                                            src={user.imageUri.indexOf('base64') > -1 ? user.imageUri : `data:image/jpeg;base64,${user.imageUri}`}
                                            alt="avatar"
                                            onClick={handleClick}
                                        />
                                    }
                                    {(user.imageUri == undefined || user.imageUri == '') &&
                                        <div style={{
                                            width: 100,
                                            height: 100,
                                            margin: 'auto',
                                            borderRadius: 50,
                                            borderWidth: 1,
                                            borderColor: 'white',
                                            borderStyle: 'solid',
                                            backgroundColor: '#428AF8',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }} onClick={handleClick}>
                                            <div style={{ fontSize: 20, textAlign: 'center', color: 'white' }}>{getUserInitials(user)}</div>
                                        </div>
                                    }
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={hiddenFileInput}
                                    onChange={handleChange}
                                    style={{ display: 'none' }}
                                />
                                <AvForm onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="12">
                                            <AvField name="firstName" label="First Name *" value={user.firstName}
                                                onChange={(e) => setUser({ ...user, firstName: e.target.value })} placeholder="Enter..." required />
                                            <AvField name="lastName" label="Last Name *" value={user.lastName}
                                                onChange={(e) => setUser({ ...user, lastName: e.target.value })} placeholder="Enter..." required />
                                            <AvField name="email" label="Email *" value={user.email}
                                                onChange={(e) => setUser({ ...user, email: e.target.value })} placeholder="Enter..." required />
                                            {/* <AvField name="password" label="Password " value={user.password} type="password"
                                                onChange={(e) => setUser({ ...user, password: e.target.value })} placeholder="Enter..." /> */}
                                            {currentUser.roleId == 110 &&
                                                <div className="form-group">
                                                    <label htmlFor="start">Start Date</label>
                                                    <DatePicker className="form-control"
                                                        selected={user.userSubscriptionStartDT}
                                                        onChange={(date) => setUser({ ...user, userSubscriptionStartDT: date })}
                                                        placeholderText="Start..."
                                                    />
                                                </div>
                                            }

                                            {currentUser.roleId == 110 &&
                                                <div className="form-group">
                                                    <label>Subscription Status</label>
                                                    <CustomInput type="select" id="subscriptionStatus" name="subscriptionStatusSelect" className='form-control'
                                                        onChange={(e) => { }}
                                                        value={user.userSubscriptionStatusID}>
                                                        <option value={0}>Lapsed or Ended</option>
                                                        <option value={1}>Trial</option>
                                                        <option value={10}>Good Standing</option>
                                                    </CustomInput>
                                                </div>
                                            }

                                        </Col>
                                    </Row>
                                    <div className="pull-right">
                                        <Button color='primary' type="submit" style={{ marginRight: '.25rem' }}>Save</Button>
                                        <Button color='link' className="pull-right" onClick={() => props.history.goBack()}>Cancel</Button>
                                    </div>
                                </AvForm>


                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="6">
                        <Braintree
                            user={user}
                            isNormalUser={true}
                            history={props.history}
                        />
                    </Col>
                </Row>
            }


            <Row style={{ marginTop: '30px' }}>
                <Col md="12">
                    <Card className="main-card mb-3">
                        <CardBody>


                            {isLoading && <Loader style={{}} type="ball-pulse" active />}
                            {!isLoading &&
                                <Row style={{ marginTop: '0px' }}>

                                    <GeneralGrid
                                        title="Partners"
                                        keyField="PartnerID"
                                        defaultSortedColumn="PartnerName"
                                        dataSource={userPartners}
                                        filterColumns={["PartnerName"]}
                                        columns={partnercolumns}
                                        showAddButton={false}
                                        //buttonText={'Add Decision'}
                                        defaultSorted={partnerdefaultSorted}
                                        options={partneroptions}
                                    //onAdd={() => goToDetails(-1)}
                                    />

                                </Row>
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row style={{ marginTop: '30px' }}>
                <Col md="12">
                    <Card className="main-card mb-3">
                        <CardBody>

                            {isLoading && <Loader style={{}} type="ball-pulse" active />}
                            {!isLoading &&
                                <Row style={{ marginTop: '0px' }}>

                                    <GeneralGrid
                                        title="Decisions"
                                        keyField="ScenarioID"
                                        defaultSortedColumn="ScenarioName"
                                        dataSource={userScenarios}
                                        filterColumns={["ScenarioName"]}
                                        columns={columns}
                                        showAddButton={false}
                                        //buttonText={'Add Decision'}
                                        defaultSorted={defaultSorted}
                                        options={options}
                                    //onAdd={() => goToDetails(-1)}
                                    />

                                </Row>
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </Fragment >
    )
}

export default FullProfileWithPaiment;